export default __webpack_public_path__ + "static/media/BumpFund_Icons_05.6337fbad.svg";